var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, clsx, Icon } from '@a-type/ui';
export function TagToggle(_a) {
    var { name, icon, color, className, onToggle, toggled } = _a, rest = __rest(_a, ["name", "icon", "color", "className", "onToggle", "toggled"]);
    return (_jsxs(Button, Object.assign({ size: "small", emphasis: "light", className: clsx(`@mode-${color} @mode-dense`, className), toggled: toggled, onClick: onToggle }, rest, { children: [_jsx(Icon, { name: icon || 'tag', size: 10 }), _jsx("span", { children: name })] })));
}
//# sourceMappingURL=TagToggle.js.map